module.exports = __webpack_public_path__ + "img/pop-bg.622b6259.png";